import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { noDefault } from 'lib/eventWrappers';

import { BillExportSettings, BillingStatus } from './model';

import { ToggleButton } from 'portcall/togglebutton/view';

export const BillExportSettingsView = SuperCritical(({ model: m } : { model : BillExportSettings }) =>
    <div className="billexportsettings">
        <div className="export-settings-header">Export Settings</div>
        <div className="export-settings-body">
            <BillableToggleView model={m} />
            <CustomerIDView model={m} />
            <ExportActionsView model={m} />
        </div>
    </div>
);

let BillableToggleView = SuperCritical(({ model: m } : { model : BillExportSettings }) =>
    <div className="export-settings-line">
        <span className="export-settings-label pc-text-billing-label">Billable</span>
        <ToggleButton
            checked={m.DraftModel.Billable}
            onLabel="Billable"
            offLabel="Non-billable"
            selectedLabelClassName="billable-toggle-selected-label"
            disabled={
                m.BillingStatus() === BillingStatus.Approved ||
                m.BillingStatus() === BillingStatus.Exported
            }
        />
    </div>
);

let CustomerIDView = SuperCritical(({ model: m } : { model : BillExportSettings }) => {
    const customerIDDisabled =
        m.BillingStatus() === BillingStatus.NonBillable ||
        m.BillingStatus() === BillingStatus.Approved ||
        m.BillingStatus() === BillingStatus.Exported;
    return (
        <div className="export-settings-line">
            {/* TH 05/03/2017 -- This is really the QuickBooks customer ID.
                If we ever add support for multiple export systems, we'll probably
                need to emphasize QuickBooks more. Other systems might easily have a
                different system for identifying the customer. */}
            <span className="export-settings-label pc-text-billing-label">Customer ID</span>
            <div className="customer-input-shell">
                <input className="customer-input"
                    value={m.BillingStatus() === BillingStatus.NonBillable ? '' : m.DraftModel.QBTracking.Customer() || ''}
                    onChange={e => m.DraftModel.QBTracking.Customer(e.currentTarget.value)}
                    disabled={customerIDDisabled}
                />
                <div
                    className={cx('customer-input-instructions', {
                        'hide-instructions': customerIDDisabled
                    })}
                >
                    Enter matching Customer ID
                </div>
            </div>
        </div>
    );
});

let ExportActionsView = SuperCritical(({ model: m } : { model : BillExportSettings }) =>
    m.BillingStatus() === BillingStatus.Exported ?
        <div className="export-settings-line export-actions">
            <span className="pc-text-smalllabel">
                Exported:
                {' '}
                {/* TH 05/09/2017 -- The 'Exported with error' language is to support the hopefully rare case
                    when we were able to generate a Bill for a PJO but encountered an error generating an IIF
                    file from that Bill (or another Bill in the same export).
                    This means that no IIF was generated, but the PJO will still appear on the Past Exports
                    page b/c it does have a Bill. Another export can be attempted from there. */}
                {m.LastExportDate() ? tzmoment(m.LastExportDate()!).format('M/D/YY') : 'Exported with error'}
            </span>
        </div> :
    m.BillingStatus() === BillingStatus.Approved ?
        <div className="export-settings-line export-actions">
            {m.CanRecalculate() &&
                <a href="" className="recalculate-link" onClick={noDefault(m.Recalculate)}>
                    Recalculate
                </a>
            }
            <span className="pc-text-smalllabel">
                Approved:
                {' '}
                {m.DraftModel.ApprovalOfCharges() ? tzmoment(m.DraftModel.ApprovalOfCharges()!.ApprovalDate()).format('M/D/YY') : ''}
            </span>
        </div> :
    <div className="export-settings-line export-actions">
        <button
            className="pc-button export-actions-button"
            onClick={m.Approve}
            disabled={!m.ValidForApproval()}
        >
            Approve for Export
        </button>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/billexportsettings/view.tsx